import { render, staticRenderFns } from "./DataTableDestroy.vue?vue&type=template&id=f6f21654&scoped=true&"
import script from "./DataTableDestroy.vue?vue&type=script&lang=js&"
export * from "./DataTableDestroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f21654",
  null
  
)

export default component.exports